import { fieldId } from '../../field-id.model';
import { HasExtrema } from './size.model';

export class ColorModel implements HasExtrema {
  constructor(
    public field_id: fieldId | null = null,
    public extrema: {
      min?: number;
      max?: number;
    } = {},
  ) {}
}

export const ColorByAreas = ['dimensions', 'breakdowns', 'series'] as const;
export type ColorByArea = (typeof ColorByAreas)[number];
